module.exports = __webpack_public_path__ + "img/secretaria-de-energia.77036ab2.png";